import { makeAutoObservable } from "mobx";
import { IRmaAction } from "./rma-page-store";

class RmaActionsToolbarStore {
    private _currentAction: IRmaAction | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public getCurrentAction(): IRmaAction | null {
        return this._currentAction;
    }

    public setCurrentAction(action: IRmaAction | null): void {
        this._currentAction = action;
    }
}

export default RmaActionsToolbarStore;
